export const createMessage = (content, role, sent) => {
  return {
    role,
    content,
    sent,
  };
};
